// src/config/menuLinks.js

export const appLinks = [
   // { name: 'a', text: 'التعريف بالمسابقة', icon: 'fas fa-info-circle fa-fw', roles: ['admin', 'contestant'] },
        // { name: 'b', text: 'الاشتراك بالمسابقة', icon: 'fas fa-user-plus fa-fw', roles: ['admin'] },
        {
          name: 'manger',
          text: 'منطقة رئيس الكنترول',
          icon: 'fas fa-user-shield fa-fw',
          roles: ['control_head'],
          
          hasChildren: true,
          children: [
            { name: 'StudentInquiryOn', text: 'استعلام عن طالب', icon: 'far fa-circle fa-fw', roles: ['control_head'] },
           
 
           
          ]
        },
        {
          name: 'AdminDashboard_0',
          text: 'منطقة اعضاء الكنترول',
          icon: 'fas fa-user-shield fa-fw',
          roles: ['control_member','admin'],
          
          hasChildren: true,
          children: [
            { name: 'StudentAbs', text: 'تسجيل الغياب', icon: 'far fa-circle fa-fw', roles: ['control_member' ,'admin'] },
            { name: 'CountStatistics', text: ' احصاء عددى سرية ', icon: 'far fa-circle fa-fw', roles: ['control_member','admin'] },
            { name: 'DeliveryPortfolio', text: ' حافظة تسليم الأوراق ', icon: 'far fa-circle fa-fw', roles: ['control_member','admin'] },
            { name: 'StoreDegreeStudent_1', text: ' رصد الدرجات _ 1 ', icon: 'far fa-circle fa-fw', roles: ['control_member','admin'] },
            
            
         
            
           
          
            // { name: 'StoreDegreeStudent', text: ' رصد الدرجات _ 4 ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
 
           
          ]
        },
        {
          name: 'Printer',
          text: 'المطبوعات',
          icon: 'fas fa-chalkboard-teacher fa-fw',
          roles: ['admin'],
          
          hasChildren: true,
          children: [
              { name: 'SeatingReviewReport', text: '   كشوف مراجعة رقم الجلوس ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'CallSheetWithSubjectsAllMange', text: 'كشف مناداة مفصل ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'CallSheet', text: 'كشف مناداة ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'SchoolCallingSheet', text: 'كشف مناداة مدرسة', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'ActivityAll', text: 'كشف النشاط ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'CallSheetWithSubjects', text: 'كشف مناداة بالمادة ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'FinalResultPrint', text: ' طباعة النتيجة ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'DigitalResultGazette', text: ' طباعة النتيجة الرقمية ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'CumulativeFrequency', text: '   تكرارى ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'CumulativeFrequency_1', text: '1   تكرارى ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'SecretRoomStaticSheet', text: 'جدول اعمال السرية ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'SuccessCertificate', text: '  استمارة النجاح ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'GroupMirrorSheet', text: '   طباعة الكلصقات ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'EnvelopeStickers', text: '   طباعة مجموعات ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'SchoolStickerPrint', text: '   طباعة استيكر مدارس ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'AbsenceEntry', text: '     استلام الكترونى  ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'CommitteeEnvelopeLabel', text: '     طباعة  اﻻظرف لجان  ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'SchoolEnvelopeLabel', text: '     طباعة  اﻻظرف مدارس  ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'ChairmanLoginSheet', text: '     طباعة  خطاب التكليف واﻻستلام   ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'SeatingCardsPrint', text: '     طباعة ارقام الجلوس   ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'AbsenceSheetEmpty', text: '     طباعة  كشف غياب فارغ   ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            
        
          ]
        },
        {
          name: 'review',
          text: 'المراجعات',
          icon: 'fas fa-chalkboard-teacher fa-fw',
          roles: ['admin'],
          
          hasChildren: true,
          children: [
            { name: 'CountStatisticsAll', text: ' احصاء عددى سرية للكل ', icon: 'far fa-circle fa-fw', roles: ['control_member','admin'] },
            { name: 'DeliveryPortfolioAll', text: ' حافظة تسليم اﻻوراق للكل ', icon: 'far fa-circle fa-fw', roles: ['control_member','admin'] },
            { name: 'ReviewGradeSheetAll', text: ' مراجعة الرصد للكل ', icon: 'far fa-circle fa-fw', roles: ['control_member','admin'] },
            { name: 'ReviewGradeSheet', text: ' مراجعة الرصد ', icon: 'far fa-circle fa-fw', roles: ['control_member','admin'] },
            { name: 'SingleGradeEdit', text: ' التعديل الدرجات  ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'GradeAudit', text: ' مراجعة الراسبين ', icon: 'far fa-circle fa-fw', roles: ['control_member','admin'] },
            { name: 'VisualGradeReview', text: '   مراجعة بصرية   ', icon: 'far fa-circle fa-fw', roles: ['control_member','admin'] },
            { name: 'AnomaliesReview', text: '   مراجعة للشواذ   ', icon: 'far fa-circle fa-fw', roles: ['control_member','admin'] },
            { name: 'MercyRulesManager', text: '    درجات الرأفة   ', icon: 'far fa-circle fa-fw', roles: ['control_member','admin'] },
            { name: 'MercyFullTable', text: '    درجات الرأفة للجميع   ', icon: 'far fa-circle fa-fw', roles: ['control_member','admin'] },
            
          ]
        },
        {
          name: 'report',
          text: 'التقارير',
          icon: 'fas fa-chalkboard-teacher fa-fw',
          roles: ['admin'],
          
          hasChildren: true,
          children: [
            { name: 'IntegrationSecretReport', text: 'تقرير الدمج ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'CommitteeSupplementaryReport', text: 'تقرير تكميلي لجان ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'SupplementaryExamReport', text: 'تقرير تكميلي مدارس ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'FullAbsenceReport', text: 'تقرير تكميلي عام ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'FrequencyReport', text: ' تحليل النتيجة الرقمية ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'MergePaperReceipt', text: '   طباعة كشوف استلام الدمج ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'LanguagePaperPrint', text: '   طباعة كشوف استلام اللغات ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'CommitteeStatsReport', text: '   احصاء عددى للجان', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            
          ]
        },
        {
          name: 'AdminDashboardTzl',
          text: 'التظلمات',
          icon: 'fas fa-chalkboard-teacher fa-fw',
          roles: ['control_member' , 'admin'],
          
          hasChildren: true,
          children: [
            { name: 'AppealsRequest', text: '    التظلمات   ', icon: 'far fa-circle fa-fw', roles: ['control_member' , 'admin'] },
            { name: 'CentralPaperMonitor', text: '    متابعة التظلمات   ', icon: 'far fa-circle fa-fw', roles: ['control_member' , 'admin'] },
            { name: 'ReadyAppealsList', text: 'تظلمات جاهزة', icon: 'far fa-circle fa-fw', roles: ['control_member' , 'admin'] },
            //  { name: 'ExamPaperViewer', text: ' عرض اوراق الطالب ', icon: 'far fa-circle fa-fw', roles: ['control_member' , 'admin'] },
            // { name: 'MultiPageScanner', text: ' تصوير اوراق الطالب ', icon: 'far fa-circle fa-fw', roles: ['control_member' , 'admin'] },
            // { name: 'PaperQualityReview', text: ' مراجعة اوراق الطالب ', icon: 'far fa-circle fa-fw', roles: ['control_member' , 'admin'] },
            { name: 'AppealReviewPage', text: ' معاينة اوراق الطالب ', icon: 'far fa-circle fa-fw', roles: ['control_member' , 'admin'] },
            { name: 'ControlEditAppeal', text: 'تعديل التظلم', icon: 'far fa-circle fa-fw', roles: ['control_member' , 'admin'] },
            { name: 'FinalAppealMonitor', text: 'اﻻنتهاء من ملف التظلم', icon: 'far fa-circle fa-fw', roles: ['control_member' , 'admin'] },
            { name: 'FinalAdminReport', text: ' كشف شئون الطلبة', icon: 'far fa-circle fa-fw', roles: ['control_member' , 'admin'] },
           
          ]
        },
        {
          name: 'AdminDashboard_R',
          text: 'منطقة رؤساء اللجان',
          icon: 'fas fa-chalkboard-teacher fa-fw',
          roles: ['committee_head'],
          
          hasChildren: true,
          children: [
            // { name: 'CommitteeChairmanAgenda', text: 'جدول اعمال الرئيس', icon: 'far fa-circle fa-fw', roles: ['committee_head'] },
            { name: 'CommitteeDistribution', text: 'بيانات اللجنة', icon: 'far fa-circle fa-fw', roles: ['committee_head'] },
            // { name: 'CommitteeAbsenceRecorder', text: 'تسجيل غياب الطلبة', icon: 'far fa-circle fa-fw', roles: ['committee_head'] },
            // { name: 'CommitteeCommunication', text: 'تعليمات الكنترول', icon: 'far fa-circle fa-fw', roles: ['committee_head'] },
          ]
        },
        {
          name: 'AdminDashboard_M',
          text: 'منطقة مدير المدرسة',
          icon: 'fas fa-school fa-fw',
          roles: ['school_manager'],
          
          hasChildren: true,
          children: [
            { name: 'SchoolManagerInstructions', text: 'جدول اعمال المدير', icon: 'far fa-circle fa-fw', roles: ['school_manager'] },
            { name: 'SchoolActivitiesEntry', text: 'رصد الأنشطة', icon: 'far fa-circle fa-fw', roles: ['school_manager'] },
            { name: 'ActivityFirstOne', text: 'طباعة كشوف النشاط', icon: 'far fa-circle fa-fw', roles: ['school_manager'] },
          ]
        },

        {
          name: 'AdminDashboard',
          text: 'الإدارة العامة',
          icon: 'fas fa-users-cog fa-fw',
          roles: ['admin','control_head'],
          
          hasChildren: true,
          children: [
           
            // { name: 'SetNumberScu', text: 'اعداد المدارس ', icon: 'far fa-circle fa-fw', roles: ['admin'] }, // مكرر في بياناتك
            // { name: 'SetNumberScu', text: 'اعداد اللجان + المدارس ', icon: 'far fa-circle fa-fw', roles: ['admin'] }, // مكرر
            // { name: 'SetNumberScu', text: 'اعداد رقم الجلوس ', icon: 'far fa-circle fa-fw', roles: ['admin'] }, // مكرر
            // { name: 'SetNumberScu', text: 'اعداد الرقم السري ', icon: 'far fa-circle fa-fw', roles: ['admin'] }, // مكرر
            // { name: 'Reports', text: 'تقارير الغياب', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            // { name: 'UsersManagement', text: ' ادارة المستخدمين ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'AdminSendInstruction', text: ' اضافة تعليمات ', icon: 'far fa-circle fa-fw', roles: ['admin','control_head'] },
            { name: 'AdminComplaintsDashboard', text: ' متابعة البلاغات ', icon: 'far fa-circle fa-fw', roles: ['admin','control_head'] },
            { name: 'AdminSentInstructionsNotes', text: ' متابعة التعليمات المرسلة ', icon: 'far fa-circle fa-fw', roles: ['admin','control_head'] },
            { name: 'AdminSentInstructionsNotes_2', text: ' متابعة التعليمات المرسلة _2 ', icon: 'far fa-circle fa-fw', roles: ['admin','control_head'] },
            { name: 'Statistics', text: ' احصائيات عامة', icon: 'far fa-circle fa-fw', roles: ['admin','control_head'] },
          
          
          ]
        },
        {
          name: 'Setting',
          text: 'اعدادات النظام',
          icon: 'fas fa-users-cog fa-fw',
          roles: ['admin'],
          
          hasChildren: true,
          children: [
               { name: 'ExternalGradeMonitoring', text: ' رصد الدرجات _ الخوارج ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'StoreDegreeStudent_2', text: ' رصد الدرجات _ 2 ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
            { name: 'StudentAbsAll', text: 'تسجيل الغياب للكل', icon: 'far fa-circle fa-fw', roles: ['admin'] },
             { name: 'SetNumberScu', text: 'اعداد اللجان ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
             { name: 'GradesCalculator', text: '  حساب المجموع ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
          { name: 'SystemSettings', text: ' اعدادات النظام ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
          { name: 'SeatingDistribution', text: ' اعدادات رقم الجلوس ', icon: 'far fa-circle fa-fw', roles: ['admin'] },
          { name: 'ExportDataCenter', text: '  تصدير ملف رقم الجلوس  ', icon: 'far fa-circle fa-fw', roles: ['admin'] },

          ]
        },
        {
          name: 'AdminDashboard_Room',
          text: ' غرفة العمليات',
          icon: 'fas fa-users-cog fa-fw',
          roles: ['operations_admin'],
          
          hasChildren: true,
          children: [
           
            { name: 'AdminSendInstruction', text: ' اضافة تعليمات ', icon: 'far fa-circle fa-fw', roles: ['operations_admin'] },
            { name: 'AdminComplaintsDashboard', text: ' متابعة البلاغات ', icon: 'far fa-circle fa-fw', roles: ['operations_admin'] },
            { name: 'AdminSentInstructionsNotes', text: ' متابعة التعليمات المرسلة ', icon: 'far fa-circle fa-fw', roles: ['operations_admin'] },
             { name: 'AdminSentInstructionsNotes_2', text: ' متابعة التعليمات المرسلة _2 ', icon: 'far fa-circle fa-fw', roles: ['admin', 'operations_admin'] },
            { name: 'Statistics', text: ' احصائيات عامة', icon: 'far fa-circle fa-fw', roles: ['admin','operations_admin'] },
              { name: 'OperationsDashboard', text: ' احصائيات2 عامة', icon: 'far fa-circle fa-fw', roles: ['admin','operations_admin'] },
                  { name: 'GeneralStatistics', text: '     طباعة التقرير العام   ', icon: 'far fa-circle fa-fw', roles: ['admin','operations_admin'] },
            { name: 'SubjectsStatistics', text: '     طباعة التقرير مواد   ', icon: 'far fa-circle fa-fw', roles: ['admin','operations_admin'] },
          ]
        },

        // {
        //   name: 'AdminDashboard_1',
        //   text: ' مطبوعات التيرم الأول',
        //   icon: 'fas fa-print fa-fw',
        //   roles: ['admin'],
          
        //   hasChildren: true,
        //   children: [
        //     { name: 'Dashboard', text: 'كشوف المناداة', icon: 'far fa-circle fa-fw', roles: ['admin'] },
       
        //   ]
        // },
        // ... (باقي الروابط كما هي في كودك الأصلي)
        // { name: 'Register', text: 'تسجيل متسابق', icon: 'fas fa-user-plus fa-fw', roles: ['admin'] },
        // { name: 'Profile', text: 'الملف الشخصي', icon: 'fas fa-id-card fa-fw', roles: ['admin', 'contestant'] }
];